var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgresscircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0289 4.36011C44.7565 4.36011 49.4378 5.29128 53.8055 7.10044C58.1733 8.90961 62.1419 11.5614 65.4848 14.9043C68.8277 18.2472 71.4794 22.2158 73.2886 26.5835C75.0978 30.9512 76.0289 35.6325 76.0289 40.3601C76.0289 45.0877 75.0978 49.769 73.2886 54.1367C71.4794 58.5044 68.8277 62.473 65.4848 65.816C62.1419 69.1589 58.1732 71.8106 53.8055 73.6198C49.4378 75.4289 44.7565 76.3601 40.0289 76.3601C35.3013 76.3601 30.62 75.4289 26.2523 73.6198C21.8846 71.8106 17.916 69.1589 14.5731 65.8159C11.2302 62.473 8.57843 58.5044 6.76926 54.1367C4.96009 49.769 4.02893 45.0877 4.02893 40.3601C4.02893 35.6325 4.9601 30.9512 6.76927 26.5835C8.57845 22.2158 11.2302 18.2472 14.5731 14.9042C17.916 11.5613 21.8846 8.9096 26.2523 7.10044C30.6201 5.29127 35.3014 4.3601 40.029 4.36011L40.0289 4.36011Z",
    stroke: "#EAECF0",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0289 4.36011C47.6314 4.36011 55.0387 6.76689 61.1892 11.2355C67.3397 15.7041 71.9177 22.0051 74.267 29.2355C76.6163 36.4659 76.6163 44.2544 74.267 51.4847C71.9177 58.7151 67.3397 65.0161 61.1892 69.4847",
    stroke: "url(#paint0_linear_277_17231)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_277_17231",
    x1: 40.0289,
    y1: 4.36011,
    x2: 40.0289,
    y2: 76.3601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgresscircle);
export default __webpack_public_path__ + "static/media/progresscircle.bb4608e3038a5f8c5012bd6317271a2a.svg";
export { ForwardRef as ReactComponent };